import { DiscountType } from "@trnsact/trnsact-shared-types";
import { Attachment, EquipmentFormValue } from "../types";

export const equipmentAttachment: Attachment = {
  model: "",
  type: "Body",
  unitCost: 0,
  category: "Truck",
  manufacturer: "",
  quantityPerAsset: 1,
  discountValue: 0,
  retailPrice: 0,
  discountType: DiscountType.Flat,
};

export const formDefaultValue: EquipmentFormValue = {
  commonInfo: {
    vin: "",
    year: "",
    make: "",
    model: "",
    class: null,
    quality: null,
    mileage: null,
    saleCost: 0,
    stockId: "",
    condition: "",
    description: "",
    retailPrice: 0,
    wholeSaleCost: 0,
    discountValue: 0,
    discountType: DiscountType.Flat,
  },
  attachments: [],
  calcPricing: {
    retail: { total: 0, attachments: 0 },
    wholesale: { total: 0, attachments: 0 },
    customer: { total: 0, equipment: 0, attachments: 0 },
  },
};
